import { combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import auth from './reducers/auth/reducer';
import user from './reducers/user/reducer';
import shops from './reducers/shops/reducer';
import hscodes from './reducers/hscodes/reducer';
import goods from './reducers/goods/reducer';
import classifications from './reducers/classifications/reducer';

const createRootReducer = (history: History) =>
	combineReducers({
		router: connectRouter(history),
		auth,
		user,
		shops,
		hscodes,
		goods,
		classifications,
	});

export default createRootReducer;
